// extracted by mini-css-extract-plugin
export default {"default":"UserInitials_default__NM8eQ"};